var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition */
import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import BackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import TrophyIcon from '@mui/icons-material/EmojiEvents';
import TvIcon from '@mui/icons-material/Tv';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import { useAppDispatch, useAppSelector, useQuery } from '../../hooks';
import { selectEvent, setEvent, setMatchesIsLoading } from '../../store/matches';
import { loadMatches, loadPairedScreens } from '../../api';
import { getMatchStatusString } from '../../types';
import { UnderLine } from '../../components/atoms/UnderLine';
import { PageWrapperNew } from '../../components/atoms/PageWrapper';
import { DataContainerNew } from '../../components/atoms/DataContainer';
import { useErrorHandler } from '../../hooks/useErrorHandler';
import { Delimiter } from '../../components/atoms/Delimiter';
import { ScreenPairDialog } from '../ScreenPair';
import { Alerts } from '../../components/molecules/Alerts/Alerts';
const commonStyles = {
    bgcolor: 'background.paper',
    borderColor: 'text.primary',
    marginRight: '8px',
    // border: 1,
    wrap: 'nowrap',
    display: 'flex',
    padding: '5px 10px',
    // borderRadius: '8px',
};
const MatchesWrapper = styled.div `
  width: 100%;
`;
const CreateGameButton = styled(Button) `
  width: 150px;
`;
const PlayersWrapper = styled.div `
  width: 100%;
  margin-top: 30px;
`;
const Title = styled.div `
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: #000;
`;
const TableCellStatusBodyText = styled.div `
  padding: 2px 9px;
  border-radius: 42px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
`;
const ClubName = styled.div `
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #ffffff;
  //text-shadow: 0px 0px 17px #53bdd3;
`;
const GirlImg = styled.img `
  width: 155px;
  height: 284px;
  margin-left: 11px;
`;
const CreateGameWrapper = styled.div `
  display: flex;
`;
const EveningGameWrapper = styled.div `
  display: flex;
  width: 100%;
  max-width: 708px;
  justify-content: space-between;
`;
const CreateGameContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin-top: 52px;
  margin-left: 43px;
`;
const NoGamesText = styled.p `
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.8);
`;
const PlayersInfoWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  width: 708px;
`;
const TopActionsWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 708px;
`;
const ScreenActions = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
`;
const screensLinkSx = {
    background: 'transparent',
    boxShadow: 'none',
    color: '#C4CDD0',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': { background: 'rgba(255, 255, 255, 0.08)', boxShadow: 'none' },
};
export const Matches = () => {
    var _a, _b, _c, _d, _e;
    const nav = useNavigate();
    const dispatch = useAppDispatch();
    // const eventId = useAppSelector(selectEventId)
    const { param: eventId } = useQuery('eventId');
    const event = useAppSelector(selectEvent);
    const { errorHandler } = useErrorHandler();
    const [isScreenDialogOpen, setScreenDialogOpen] = useState(false);
    const [screensCount, setScreensCount] = useState(null);
    const getMatches = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!eventId)
            return;
        try {
            dispatch(setMatchesIsLoading(true));
            const result = yield loadMatches(eventId);
            // console.log('Matches getMatches', result)
            dispatch(setEvent(result));
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('Matches getMatches error', e);
            errorHandler(e);
        }
        finally {
            dispatch(setMatchesIsLoading(false));
        }
    }), [eventId, dispatch]);
    useEffect(() => {
        getMatches();
    }, [eventId, getMatches]);
    const onClickCreateMatch = () => {
        if (!eventId)
            return;
        nav(`/create-match?eventId=${eventId}`);
    };
    const onMatchClick = (match) => nav(`/match-config?matchId=${match.id}`);
    const onClickBack = () => {
        nav('/');
    };
    const getScreensCount = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!eventId)
            return;
        try {
            setScreensCount((yield loadPairedScreens(eventId)).length);
        }
        catch (e) {
            // the counter is a hint only, the screens page shows the errors
            setScreensCount(null);
        }
    }), [eventId]);
    useEffect(() => {
        getScreensCount();
    }, [getScreensCount]);
    const onClickConnectScreen = () => {
        if (!eventId)
            return;
        setScreenDialogOpen(true);
    };
    const playerName = (player) => {
        var _a;
        let data = '';
        if (player.player.gameName) {
            data = `${(_a = player.player) === null || _a === void 0 ? void 0 : _a.gameName} (${player.player.realName})`;
        }
        else {
            data = `${player.player.realName}`;
        }
        if (player.quantity > 1) {
            data += ` +${player.quantity}`;
        }
        return data;
    };
    // console.log('Matches event', event)
    return (_jsxs(DataContainerNew, { children: [_jsx(Alerts, {}), _jsxs(PageWrapperNew, { children: [_jsxs(TopActionsWrapper, { children: [_jsx(Button, { sx: { width: 120 }, startIcon: _jsx(BackIcon, {}), onClick: onClickBack }), _jsxs(ScreenActions, { children: [screensCount !== null && (_jsx(Button, Object.assign({ sx: screensLinkSx, onClick: () => nav(`/screen-pair?eventId=${eventId}`) }, { children: `Экраны: ${screensCount}` }))), _jsx(Button, Object.assign({ variant: "contained", startIcon: _jsx(TvIcon, {}), onClick: onClickConnectScreen }, { children: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u044D\u043A\u0440\u0430\u043D" }))] })] }), eventId && (_jsx(ScreenPairDialog, { open: isScreenDialogOpen, eventId: eventId, onClose: () => setScreenDialogOpen(false), onPaired: getScreensCount })), _jsx(Delimiter, { top: "19px" }), _jsx(ClubName, { children: `${(event === null || event === void 0 ? void 0 : event.date) || ''}` }), ((_a = event === null || event === void 0 ? void 0 : event.matches) === null || _a === void 0 ? void 0 : _a.length) !== 0 ? (_jsxs(_Fragment, { children: [_jsx(Delimiter, { top: "30px" }), _jsxs(MatchesWrapper, { children: [_jsx(EveningGameWrapper, { children: _jsx(Typography, Object.assign({ variant: "h2" }, { children: "\u0418\u0433\u0440\u044B \u0432\u0435\u0447\u0435\u0440\u0430" })) }), _jsx(Delimiter, { top: "20px" }), _jsx(TableContainer, Object.assign({ sx: { width: 708 }, component: Paper }, { children: _jsxs(Table, Object.assign({ "aria-label": "customized table" }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u2116" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0412\u0435\u0434\u0443\u0449\u0438\u0439" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0418\u0433\u0440\u043E\u043A\u043E\u0432" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0421\u0442\u0430\u0442\u0443\u0441" }))] }) }), _jsx(TableBody, { children: (_b = event === null || event === void 0 ? void 0 : event.matches) === null || _b === void 0 ? void 0 : _b.map((match, index) => {
                                                        var _a;
                                                        return (_jsxs(TableRow, Object.assign({ onClick: () => onMatchClick(match) }, { children: [_jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: index + 1 })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: ((_a = match.gameMaster) === null || _a === void 0 ? void 0 : _a.gameName) || '' })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: match.playersCount })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: _jsx(TableCellStatusBodyText, Object.assign({ status: match.status }, { children: getMatchStatusString(match.status) })) }))] }), match.id));
                                                    }) })] })) }))] }), _jsx(Delimiter, { top: "30px" }), _jsx(Button, Object.assign({ sx: { width: 'fit-content' }, variant: "contained", startIcon: _jsx(AddIcon, {}), onClick: onClickCreateMatch }, { children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u0433\u0440\u0443" })), _jsx(Delimiter, { top: "40px" })] })) : (_jsxs(_Fragment, { children: [_jsx(CreateGameWrapper, { children: _jsxs(CreateGameContainer, { children: [_jsx(Typography, Object.assign({ variant: "h2" }, { children: "\u0418\u0433\u0440\u044B \u0432\u0435\u0447\u0435\u0440\u0430" })), _jsx(Delimiter, { top: "14px" }), _jsx(NoGamesText, { children: "\u041F\u043E\u043A\u0430 \u043D\u0438 \u043E\u0434\u043D\u043E\u0439 \u0438\u0433\u0440\u044B \u043D\u0430 \u0432\u0435\u0447\u0435\u0440 \u043D\u0435 \u0441\u043E\u0437\u0434\u0430\u043D\u043E" }), _jsx(Delimiter, { top: "40px" }), _jsx(CreateGameButton, Object.assign({ variant: "contained", startIcon: _jsx(AddIcon, {}), onClick: onClickCreateMatch }, { children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u0433\u0440\u0443" }))] }) }), _jsx(Delimiter, { top: "20px" })] })), _jsx(UnderLine, { theme: { borderColor: 'rgba(255, 255, 255, 0.2)' } }), _jsxs(PlayersWrapper, { children: [_jsx(Typography, Object.assign({ variant: "h2" }, { children: "\u041F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0437\u0430\u043F\u0438\u0441\u0430\u0432\u0448\u0438\u0435\u0441\u044F \u043D\u0430 \u0432\u0435\u0447\u0435\u0440 \u0438\u0433\u0440\u043E\u043A\u0438" })), _jsx(Delimiter, { top: "20px" }), _jsxs(PlayersInfoWrapper, { children: [_jsxs(Stack, Object.assign({ direction: "row", spacing: 1 }, { children: [_jsx(Chip, { label: `Всего игроков: ${((_c = event === null || event === void 0 ? void 0 : event.players) === null || _c === void 0 ? void 0 : _c.length) || '0'}` }), _jsx(Chip, { label: `В игре: ${((_d = event === null || event === void 0 ? void 0 : event.players) === null || _d === void 0 ? void 0 : _d.length) || '0'}` }), _jsx(Chip, { label: "\u0421\u0432\u043E\u0431\u043E\u0434\u043D\u044B: 0" })] })), _jsx(Button, Object.assign({ variant: "contained", onClick: () => nav(`/match-leaders?eventId=${eventId}`), startIcon: _jsx(TrophyIcon, {}) }, { children: "\u041B\u0443\u0447\u0448\u0438\u0435 \u0438\u0433\u0440\u043E\u043A\u0438 \u0432\u0435\u0447\u0435\u0440\u0430" }))] }), _jsx(TableContainer, Object.assign({ sx: { width: 708 }, component: Paper }, { children: _jsxs(Table, Object.assign({ "aria-label": "customized table" }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0418\u0433\u0440\u043E\u043A" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0438\u0433\u0440" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0421\u0442\u0430\u0442\u0443\u0441" }))] }) }), _jsx(TableBody, { children: (_e = event === null || event === void 0 ? void 0 : event.players) === null || _e === void 0 ? void 0 : _e.map((player) => {
                                                var _a;
                                                return (_jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: playerName(player) })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: ((_a = player.player) === null || _a === void 0 ? void 0 : _a.gamesCount) || 0 })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: player.status }))] }, player.id));
                                            }) })] })) }))] })] })] }));
};
